module.exports = __webpack_public_path__ + "img/ronaldo.70b69115.jpg";